import { render, staticRenderFns } from "./artist-box.vue?vue&type=template&id=3ef2496e&"
import script from "./artist-box.vue?vue&type=script&lang=js&"
export * from "./artist-box.vue?vue&type=script&lang=js&"
import style0 from "./artist-box.vue?vue&type=style&index=0&id=3ef2496e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports